<template>
  <div>
    <el-card shadow="hover" v-loading="loading">
      <div slot="header" class="header">
        <div class="title">
          <span>智能柜</span>
          <el-tag v-if="list.length" size="mini" type="info" style="margin-left:8px;">{{ list.length }} 条</el-tag>
        </div>
        <div>
          <el-input
            v-model.trim="query.keyword"
            size="small"
            clearable
            placeholder="搜索名称/编号/责任人/电话"
            style="width: 240px; margin-right: 8px;"
            @keyup.enter.native="refresh"
          />
          <el-button size="small" @click="refresh">刷新</el-button>
          <el-button type="primary" size="small" @click="openCreate">新增智能柜</el-button>
        </div>
      </div>

      <el-table :data="list" border stripe highlight-current-row empty-text="暂无智能柜">
        <el-table-column type="index" label="序号" width="80" />
        <el-table-column prop="org_name" label="机构名称" width="160" />
        <el-table-column prop="name" label="智能柜名称" />
        <el-table-column prop="code" label="智能柜编号" width="160" />
        <el-table-column prop="door_status" label="柜门状态(设备)" width="130">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.door_status) === 1" type="success" size="mini">开</el-tag>
            <el-tag v-else-if="Number(scope.row.door_status) === 2" type="info" size="mini">关</el-tag>
            <el-tag v-else type="warning" size="mini">未上报</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_open" label="远程开门指令" width="130">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.is_open) === 1" type="warning" size="mini">待执行</el-tag>
            <el-tag v-else type="info" size="mini">无</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="owner_name" label="责任人" width="120" />
        <el-table-column prop="owner_phone" label="责任人电话" width="140" />
        <el-table-column label="操作" width="260" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="actions">
              <el-button
                type="success"
                size="mini"
                :loading="openingId === Number(scope.row.id)"
                @click="onOpen(scope.row)"
              >
                远程开门
              </el-button>
              <div class="actions-right">
                <el-button size="mini" plain @click="openEdit(scope.row)">编辑</el-button>
                <el-button type="danger" size="mini" plain @click="onDelete(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="新增智能柜" :visible.sync="createVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="createRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="绑定机构" prop="orgId">
          <el-select
            v-model="form.orgId"
            filterable
            remote
            clearable
            placeholder="输入机构名称进行搜索（可不选）"
            :remote-method="fetchOrgs"
            :loading="orgLoading"
            style="width: 100%;"
          >
            <el-option v-for="o in orgOptions" :key="o.id" :label="o.name" :value="Number(o.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="智能柜名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="128" show-word-limit />
        </el-form-item>
        <el-form-item label="智能柜编号" prop="code">
          <el-input v-model.trim="form.code" maxlength="64" show-word-limit />
        </el-form-item>
        <el-form-item label="责任人">
          <el-input v-model.trim="form.ownerName" maxlength="64" show-word-limit />
        </el-form-item>
        <el-form-item label="责任人电话">
          <el-input v-model.trim="form.ownerPhone" maxlength="32" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="doCreate">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑智能柜" :visible.sync="editVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="editRef" :model="editForm" :rules="rules" label-width="110px">
        <el-form-item label="绑定机构" prop="orgId">
          <el-select
            v-model="editForm.orgId"
            filterable
            remote
            clearable
            placeholder="输入机构名称进行搜索（可不选）"
            :remote-method="fetchOrgs"
            :loading="orgLoading"
            style="width: 100%;"
          >
            <el-option v-for="o in orgOptions" :key="o.id" :label="o.name" :value="Number(o.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="智能柜名称" prop="name">
          <el-input v-model.trim="editForm.name" maxlength="128" show-word-limit />
        </el-form-item>
        <el-form-item label="智能柜编号" prop="code">
          <el-input v-model.trim="editForm.code" maxlength="64" show-word-limit />
        </el-form-item>
        <el-form-item label="责任人">
          <el-input v-model.trim="editForm.ownerName" maxlength="64" show-word-limit />
        </el-form-item>
        <el-form-item label="责任人电话">
          <el-input v-model.trim="editForm.ownerPhone" maxlength="32" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="doEdit">保存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getCabinets, createCabinet, updateCabinet, deleteCabinet, searchOrgs, remoteOpenCabinet } from "@/api";

export default {
  name: "Cabinet",
  data() {
    return {
      list: [],
      loading: false,
      openingId: null,
      createVisible: false,
      editVisible: false,
      saving: false,
      orgLoading: false,
      orgOptions: [],
      query: {
        keyword: ""
      },
      form: {
        orgId: null,
        name: "",
        code: "",
        ownerName: "",
        ownerPhone: ""
      },
      editForm: {
        id: null,
        orgId: null,
        name: "",
        code: "",
        ownerName: "",
        ownerPhone: ""
      },
      rules: {
        orgId: [{ type: "number", message: "请选择机构（可不选）", trigger: "change" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入编号", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      try {
        const res = await getCabinets({ keyword: this.query.keyword || "" });
        this.list = (res && res.data && res.data.list) || [];
      } catch (e) {
        this.$message.error("加载失败");
      } finally {
        this.loading = false;
      }
    },
    async fetchOrgs(keyword) {
      this.orgLoading = true;
      try {
        const res = await searchOrgs({ keyword: keyword || "" });
        this.orgOptions = (res && res.data && res.data.list) || [];
      } catch (e) {
        this.orgOptions = [];
      } finally {
        this.orgLoading = false;
      }
    },
    openCreate() {
      this.form = { orgId: null, name: "", code: "", ownerName: "", ownerPhone: "" };
      this.createVisible = true;
      this.$nextTick(() => this.$refs.createRef && this.$refs.createRef.clearValidate());
      this.fetchOrgs("");
    },
    openEdit(row) {
      const r = row || {};
      this.editForm = {
        id: Number(r.id) || null,
        orgId: r.org_id != null ? Number(r.org_id) : null,
        name: r.name || "",
        code: r.code || "",
        ownerName: r.owner_name || "",
        ownerPhone: r.owner_phone || ""
      };
      this.editVisible = true;
      this.$nextTick(() => this.$refs.editRef && this.$refs.editRef.clearValidate());
      this.fetchOrgs("");
    },
    async doCreate() {
      this.$refs.createRef.validate(async (ok) => {
        if (!ok) return;
        this.saving = true;
        try {
          await createCabinet(this.form);
          this.$message.success("已创建");
          this.createVisible = false;
          await this.refresh();
        } catch (e) {
          this.$message.error("创建失败（需要 admin 权限）");
        } finally {
          this.saving = false;
        }
      });
    },
    async doEdit() {
      this.$refs.editRef.validate(async (ok) => {
        if (!ok) return;
        this.saving = true;
        try {
          await updateCabinet(this.editForm);
          this.$message.success("已保存");
          this.editVisible = false;
          await this.refresh();
        } catch (e) {
          this.$message.error("保存失败（需要 admin 权限）");
        } finally {
          this.saving = false;
        }
      });
    },
    async onDelete(row) {
      const id = Number(row && row.id);
      if (!id) return;
      try {
        await this.$confirm(`确认删除智能柜？\n智能柜：${row.name || "-"}（${row.code || "-"}）`, "删除", { type: "warning" });
      } catch (e) {
        return;
      }
      this.saving = true;
      try {
        await deleteCabinet(id);
        this.$message.success("已删除");
        await this.refresh();
      } catch (e) {
        this.$message.error("删除失败（需要 admin 权限）");
      } finally {
        this.saving = false;
      }
    },
    async onOpen(row) {
      const id = Number(row && row.id);
      if (!id) return;
      try {
        await this.$confirm(
          `确认远程开门？\n智能柜：${row.name || "-"}（${row.code || "-"}）`,
          "远程开门",
          { type: "warning" }
        );
      } catch (e) {
        return;
      }

      this.openingId = id;
      try {
        await remoteOpenCabinet(id);
        this.$message.success("已发送开门指令");
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && (e.response.data.message || e.response.data.errMsg)) ||
          "开门失败（请检查权限/后端）";
        this.$message.error(msg);
      } finally {
        this.openingId = null;
      }
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.actions-right {
  display: inline-flex;
  gap: 6px;
  flex-wrap: nowrap;
  white-space: nowrap;
}
</style>

